import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import CustomButton from '../components/styled/CustomButton'
import { Button, Checkbox, FormControlLabel } from '@mui/material'
import CheckboxUnchecked from '../assets/imgs/checkbox-unchecked.svg'
import CheckedCheckbox from '../assets/imgs/checked-checkbox.svg'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const NotificationsModal = ({
  hanldeNotificationModal,
  notificationsModalOpen = false,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [notificationsPermission, setNotificationsPermissions] = React.useState(
    {
      push_notification: false,
      update_notification: false,
      offer_notification: false,
      email_notification: false,
    },
  )
  const [isLoading, setIsLoading] = React.useState(false)

  const handleNotificationsPermission = async () => {
    try {
      let body = {
        ...notificationsPermission,
        user_id: user?.id,
      }
      setIsLoading(true)
      let result = await saveOrUpdateDataById('allow-notification', body)
      if (result?.success === true && result?.data != null) {
        Swal.fire({
          icon: 'success',
          title: 'Notifications permissions updated successfully!',
          confirmButtonColor: '#2597F6',
        })
      }
      hanldeNotificationModal(false)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={notificationsModalOpen}
        onClose={() => hanldeNotificationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Notifications</h3>
            <div className="text-left">
              <p className="fs-16 font-weight-bold">
                You’ll always receive push notification updates for your account
                activity.
              </p>
              <p className="fs-16 font-weight-bold mt-4 text-left">
                Push Notifications
              </p>
              <div className="my-1 mx-0 text-left">
                <FormControlLabel
                  onClick={(e) =>
                    setNotificationsPermissions((prev) => ({
                      ...prev,
                      push_notification: e.target.checked,
                    }))
                  }
                  control={
                    <Checkbox
                      checkedIcon={
                        <img src={CheckedCheckbox} alt="Checked Icon" />
                      }
                      icon={
                        <img
                          src={CheckboxUnchecked}
                          alt="Checkbox Unchecked Icon"
                        />
                      }
                    />
                  }
                  label={'Style recommendations and offers'}
                />
              </div>
              <p className="fs-16 font-weight-bold m-0 text-left">
                Text Messages
              </p>
              <div className="my-1 mx-0 text-left">
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={(e) =>
                        setNotificationsPermissions((prev) => ({
                          ...prev,
                          update_notification: e.target.checked,
                        }))
                      }
                      checkedIcon={
                        <img src={CheckedCheckbox} alt="Checked Icon" />
                      }
                      icon={
                        <img
                          src={CheckboxUnchecked}
                          alt="Checkbox Unchecked Icon"
                        />
                      }
                    />
                  }
                  label={'Style updates from us and your stylist'}
                />
              </div>
              <div className="my-1 mx-0 text-left">
                <FormControlLabel
                  onClick={(e) =>
                    setNotificationsPermissions((prev) => ({
                      ...prev,
                      offer_notification: e.target.checked,
                    }))
                  }
                  control={
                    <Checkbox
                      checkedIcon={
                        <img src={CheckedCheckbox} alt="Checked Icon" />
                      }
                      icon={
                        <img
                          src={CheckboxUnchecked}
                          alt="Checkbox Unchecked Icon"
                        />
                      }
                    />
                  }
                  label={'Style recommendations and offers'}
                />
              </div>
              <p className="fs-16 font-weight-bold m-0 text-left">
                Email Notifications
              </p>
              <div className="my-1 mx-0 text-left">
                <FormControlLabel
                  onClick={(e) =>
                    setNotificationsPermissions((prev) => ({
                      ...prev,
                      email_notification: e.target.checked,
                    }))
                  }
                  control={
                    <Checkbox
                      checkedIcon={
                        <img src={CheckedCheckbox} alt="Checked Icon" />
                      }
                      icon={
                        <img
                          src={CheckboxUnchecked}
                          alt="Checkbox Unchecked Icon"
                        />
                      }
                    />
                  }
                  label={'Style recommendations and offers'}
                />
              </div>
            </div>
            <Button
              disableElevation
              fullWidth
              id="btn-primary-no-shadow"
              className="mt-4"
              onClick={handleNotificationsPermission}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default NotificationsModal
